module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dl', {
    staticClass: "my-browser-define"
  }, [_c('dt', [_vm._v("Chrome（PC）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])]), _vm._v(" "), _c('dt', [_vm._v("Firefox（PC）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.mozilla.org/ja/kb/enable-and-disable-cookies-website-preferences",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])]), _vm._v(" "), _c('dt', [_vm._v("Internet Explorerをお使いの場合")]), _vm._v(" "), _c('dd', [_c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("[インターネットオプション]を開く")]), _vm._v(" "), _c('li', [_vm._v("[詳細設定]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("セキュリティの[DOMストレージを有効にする]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("[全般]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[閲覧の履歴]の[設定]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[キャッシュおよびデータベース]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[Web サイトのキャッシュおよびデータベースを許可する]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("[OK]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("Windows (PC) を再起動する")])])]), _vm._v(" "), _c('dt', [_vm._v("Safari(iOS)をお使いの場合")]), _vm._v(" "), _c('dd', [_c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("設定 > Safari > Cookieをブロック へ進む")]), _vm._v(" "), _c('li', [_vm._v("「常にブロック」以外を選択する")])])]), _vm._v(" "), _c('dt', [_vm._v("Chrome（Android）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d242a16","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/partials/HowToCookie.vue
// module id = 460
// module chunks = 1